




















































import {
  computed,
  defineComponent,
  onMounted,
  ref,
  toRefs,
  useRoute
} from '@nuxtjs/composition-api'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import { ciTradesMatch } from '~/icons/source/regular/trades-match'

export default defineComponent({
  components: { CAvatar },
  props: {
    width: { type: Number, required: false, default: 90 },
    height: { type: Number, required: false, default: 90 },
    recommendedClassifiedImg: { type: String, required: true },
    recommendedClassifiedTitle: { type: String, required: false },
    recommendedClassifiedId: { type: [Number, String], required: true },
    matchedClassifiedImg: { type: String, required: true },
    matchedClassifiedTitle: { type: String, required: false },
    matchedClassifiedId: { type: [String, Number], required: false },
    animate: { type: Boolean, required: false, default: false }
  },
  setup(props) {
    const { recommendedClassifiedId, matchedClassifiedId } = toRefs(props)
    const route = useRoute()
    const inIframe = computed(() => {
      return Boolean(route.value.meta?.isIframe)
    })
    const triggerTransitions = ref(false)

    onMounted(() => {
      setTimeout(() => {
        triggerTransitions.value = true
      }, 150) // 150 = swipe-up transition time/2
    })

    const recommendedClassifiedUrl = computed(() => {
      return `/${recommendedClassifiedId.value}`
    })
    const matchedClassifiedIdUrl = computed(() => {
      return `/${matchedClassifiedId.value}`
    })

    return {
      ciTradesMatch,
      inIframe,
      recommendedClassifiedUrl,
      matchedClassifiedIdUrl,
      triggerTransitions
    }
  }
})
